export default () => ({
  trigger: {
    name: 'options_row.open_product_summary',
    params: {},
  },
  config: {
    event: {
      name: 'select_content',
      params: {
        sub_feature: null,
        content: 'product_summary_overlay',
      },
    },
  },
});
